var React = require('react');
var ReactNative = require('react-native');

var moment = require('moment');

var Animated = require('./wrappers/Animated')

var Globals = require('./Globals');
var NetworkManager = require('./NetworkManager.js');
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpButton = require('./ReUpButton.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var ReUpText = require('./ReUpText');
var RewardsList = require('./RewardsList.js');
var PlatformConstants = require('./constants/PlatformConstants');
import Icon from './wrappers/ReUpIcon';

var {
  AppRegistry,
  Text,
  View,
  Image,
  ScrollView,
  StyleSheet,
} = ReactNative;

var GiftCardUseReward = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
      extras : {},
    }
  },

  getInitialState : function()
  {
    return {
      layout : this.props.initialLayout,
      chargeText : "Charge - $0.00",
      rewards : [],
      oneTimeRewards : [],
    }
  },

  componentDidMount : function()
  {
    var thisThing = this;
    NetworkManager.getOneTimeRewards( this.props.appManager, this.props.extras.UserID, this.props.extras.hash, (data)=>
    {
      var deduplicatedOneTimeRewards = [];
      for( var i = 0; i < data.length; i++ )
      {
        var alreadyExists = false;
        var reward = data[i];
        for( var j = 0; j < deduplicatedOneTimeRewards.length; j++ )
        {
          if( reward.RewardID == deduplicatedOneTimeRewards[j].RewardID )
          {
            if( typeof deduplicatedOneTimeRewards[j].others === 'undefined' ) deduplicatedOneTimeRewards[j].others = [];
            deduplicatedOneTimeRewards[j].others.push(reward);
            alreadyExists = true;
          }
        }
        if( !alreadyExists )
        {
          deduplicatedOneTimeRewards.push(reward);
        }
      }
      thisThing.setState({oneTimeRewards:deduplicatedOneTimeRewards});
    }, ()=>
    {
    })
  },

  didUpdate : function(data)
  {
    if( typeof data.Rewards !== 'undefined' )
    {
      var rewards = data.Rewards.sort(function(a,b)
      {
        if( a.Points == b.Points ) return b.RewardName.localeCompare(a.RewardName);
        else return a.Points - b.Points;
      });

      this.setState({rewards})
    }
  },

  didSelectReward : function(reward)
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    var appActions = this.props.appActions;
    var pointsLoc = appManager.getLocalizationManager().localizedPoints(reward.Points);
    var ptsLoc = appManager.getLocalizationManager().localizedPts(reward.Points);
    var redeemRewardAlertTitle = locManager.localizedStringForKeyAndParams("REDEEM_REWARD_ALERT_TITLE", [reward.RewardName]);
    var redeemRewardAlertBody = locManager.localizedStringForKeyAndParams("REDEEM_REWARD_ALERT_BODY", [pointsLoc]);
    var usePointsAlertButton = locManager.localizedStringForKeyAndParams()
    appActions.showLocalizedAlert(redeemRewardAlertTitle, redeemRewardAlertBody, ["NO_ALERT_BUTTON",usePointsAlertButton], [function()
    {
      appActions.hideAlert();
    },function()
    {
      appActions.hideAlert();
      appActions.setSpinnerShown(true, "Processing...");
      var scanner = thisThing.props.extras.scanner;
      NetworkManager.vendorRedeemReward(appManager, thisThing.props.extras.U, reward.RewardID, "U", thisThing.props.extras.H, function(data)
      {
        appActions.setSpinnerShown(false);
        var extras = data;
        extras.success = true;
        extras.type = "credit";
        extras.scanner = scanner;
        extras.isReward = true;
        extras.reward = reward;
        appActions.requestFeatureName("TransactionResult", extras);
      }, function(data)
      {
        appActions.setSpinnerShown(false);
        var extras = data;
        extras.success = false;
        extras.type = "credit";
        extras.scanner = scanner;
        extras.isReward = true;
        extras.reward = reward;
        appActions.requestFeatureName("TransactionResult", extras);
      }, function(data)
      {
        appActions.setSpinnerShown(false);
        appActions.showNetworkErrorAlert(appActions.hideAlert, appActions.hideAlert)
      })
    }], function(){})
  },

  render: function()
  {
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    var thisThing = this;
    var generalColor = appManager.getColorForKey("GeneralColor");

    var rewards = this.state.rewards.sort(function(a,b)
    {
      return a.Points - b.Points;
    });


    var oneTimeRewards = this.state.oneTimeRewards.sort(function(a,b)
    {
      if( a.DateExpires == b.DateExpires ) return b.RewardName.localeCompare(a.RewardName);
      else 
      {
        var dateA = new Date(a.DateExpires.replace(' ', 'T')+'Z')
        var dateSecondsA = moment(dateA).valueOf();
        var dateB = new Date(b.DateExpires.replace(' ', 'T')+'Z')
        var dateSecondsB = moment(dateB).valueOf();

        return dateSecondsA - dateSecondsB;
      }
    });

    var shownRewards = [];
    for( var i = 0; i < oneTimeRewards.length; i++ ) shownRewards.push(oneTimeRewards[i]);
    for( var i = 0; i < rewards.length; i++ ) shownRewards.push(rewards[i]);

    var userPoints = this.props.extras.Points;

    return (
      <View style={[styles.container, {paddingTop:20, backgroundColor:generalColor}]}>
        <ReUpScrollView responder={this}>
          <View style={{flexDirection:'column'}}>

            <RewardsList appManager={appManager} numUserPoints={userPoints} rewards={shownRewards} didSelectReward={thisThing.didSelectReward} />
          </View>
        </ReUpScrollView>
        <ReUpButton isSecondary={true} style={[styles.button,{margin:10}]}
          appManager={appManager}
          text={locManager.localizedStringForKey("CANCEL_BUTTON")}
          onPress={() =>
          {
            thisThing.props.appActions.requestPop();
          }}
          />
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
    backgroundColor:'white'
  },
  actionBarSpacer: {
    height:0,//Globals.ACTION_BAR_HEIGHT,
  },
  image: {
    position: 'absolute',
  },
});


GiftCardUseReward.dataDependencies = ["Rewards"]

module.exports = GiftCardUseReward;



// WEBPACK FOOTER //
// ./src/GiftCardUseReward.js